import React from 'react';
import { color } from './constants';

const Loader = () => (
    <div className = 'loader'>
        <Icon />
        <div className = 'loader-text'>Loading...</div>
    </div>
)

const Icon = ({ borderColor = color.primary }) => (
    <div className = 'loader-icon' style = {{ borderColor: `transparent ${ borderColor } ${ borderColor }` }}>
    </div>
)

export default Loader;